// src/pages/Features.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Container, Typography, Grid, Box, Paper } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonIcon from '@mui/icons-material/Person';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const Features = () => {
  const { t, language } = useLanguage();

  const features = [
    {
      icon: <RestaurantIcon sx={{ fontSize: 40 }} />,
      title: 'restaurant_features_title',
      description: 'restaurant_features_description'
    },
    {
      icon: <DirectionsCarIcon sx={{ fontSize: 40 }} />,
      title: 'driver_features_title',
      description: 'driver_features_description'
    },
    {
      icon: <PersonIcon sx={{ fontSize: 40 }} />,
      title: 'customer_features_title',
      description: 'customer_features_description'
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 40 }} />,
      title: 'speed_features_title',
      description: 'speed_features_description'
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      title: 'security_features_title',
      description: 'security_features_description'
    },
    {
      icon: <SupportAgentIcon sx={{ fontSize: 40 }} />,
      title: 'support_features_title',
      description: 'support_features_description'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ 
        fontWeight: 'bold',
        textAlign: 'center',
        mb: 2
      }}>
        {t('features')}
      </Typography>

      <Typography variant="h6" sx={{ 
        textAlign: 'center',
        mb: 6,
        color: 'text.secondary'
      }}>
        {t('features_description')}
      </Typography>

      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Paper elevation={3} sx={{ 
              p: 4,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}>
              <Box sx={{ 
                color: 'primary.main',
                mb: 2
              }}>
                {feature.icon}
              </Box>
              <Typography variant="h5" component="h3" gutterBottom sx={{ 
                fontWeight: 'bold',
                mb: 2
              }}>
                {t(feature.title)}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {t(feature.description)}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Features;
